import { Footer } from "../../../Footer/Footer"
import { HerosectionsAll } from "../../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../../IndexPage/Header/Header"


export const BuilderRisksClaims = () => {
    return (
        <>
 <div className="container-fluid">
            <div className="row " style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>
                <div className="col-12">
                    <Header actives="BuilderRisksClaims" />
                    <HerosectionsAll ScreenName="Builder’s Risks  Claims" ScreenSearch="builder_risk" />

                    <div className="row col-lg-9 mx-auto p-2 p-lg-5 my-5">
                        <div className="col-12 p-lg-5 faint" style={{ textAlign: 'justify', }}>
                            <h5 className="fw-bold gray_color py-3">Builder’s Risks  Claims</h5>

                            <p>
                                Builder’s Risks policy is “All Risks” policy unlike other named perils policies of Hull Insurance. Till the vessel is built and delivered to the shipowner as per the ship building contract, the Ship builder has the insurable interest and can insure the risks associated with the ship building. All risks are covered when the ship is under constructions at builder’s or sub-contractor’s yard, within port or place of construction and also when in transit between such locations.
                            </p>

                            <p>
                                We assist in interpretation and application of the policy contact wordings for submitted claim and assist in presentation and handling the claim from intimation till final settlement. We also provide the services in cost analysis towards the invoices and estimates submitted in support of the claims.
                            </p>

                        </div>
                    </div>

                    <Footer />
                </div>
            </div>
</div>

        </>
    )
}
